<template>
  <div class="d-flex align-items-center position-relative">
    <span class="svg-icon svg-icon-1 position-absolute ms-6">
      <i
        :class="`bi bi-search fs-3 ${inputValue !== '' ? 'text-gray-700' : ''}`"
      ></i>
    </span>
    <input
      :id="`search-input-${searchId}`"
      type="text"
      @keydown.enter="searchLocation()"
      @keyup.delete="inputNull()"
      class="form-control ps-15 form-control-sm input-Filter-search"
      :placeholder="translate(PlaceHolder)"
      :style="InputStyle"
      v-model="inputValue"
      :disabled="Disabled"
    />
    <div class="position-relative">
      <button
        :style="InputStyle"
        class="
          btn btn-sm btn-icon btn-bg-light btn-active-color-primary
          border border-radius-right
        "
        type="button"
        :id="`search-input-button-${searchId}`"
        :disabled="Disabled"
      >
        <i class="bi bi-three-dots fs-3"></i>
      </button>
      <span
        v-if="filterBadge.length > 0"
        class="
          position-absolute
          top-100
          start-0
          translate-middle
          badge badge-primary
        "
        style="z-index: 2"
        >{{ translate(filterBadge[0].name) }}</span
      >
      <transition name="made">
        <ul
          v-show="filterMenuShow"
          class="position-absolute select-menu-list rounded shadow-sm"
          name=""
        >
          <li
            v-for="(item, index) in filterItemList"
            :key="index"
            :class="`rounded ${item.checked === true ? 'select-item' : ''}`"
          >
            <div
              class="
                form-check form-check-custom form-check-solid form-check-sm
              "
            >
              <input
                class="form-check-input"
                type="checkbox"
                :id="`filter-check-${index + '-' + searchId}`"
                v-model="item.checked"
                @change="selectFilter(item)"
              />
              <label
                class="form-check-label w-100"
                :for="`filter-check-${index + '-' + searchId}`"
              >
                {{ translate(item.name) }}
              </label>
            </div>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  computed,
  defineProps,
  defineEmits,
  onMounted,
} from "vue";
import { useI18n } from "vue-i18n";

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const props = defineProps({
  filterList: Array,
  searchId: Number,
  InputStyle: String,
  PlaceHolder: String,
  Disabled: Boolean,
});
const emit = defineEmits(["onFilterSearch"]);
// Filter
const filterBadge = computed(() =>
  filterItemList.value.filter((item) => item.checked === true)
);
const filterMenuShow = ref(false);
const filterItemList = ref([]);

const computedFilterItemList = computed(() => filterItemList.value.length);
const createFilterList = () => {
  var count = 0;
  props.filterList.forEach((item) => {
    count++;
    let filterItem = { name: "", checked: false };
    if (count <= 1) {
      filterItem.name = item;
      filterItem.checked = true;
      filterItemList.value.push(filterItem);
    } else {
      filterItem.name = item;
      filterItemList.value.push(filterItem);
    }
  });
};

const inputValue = ref("");

const selectFilter = (item) => {
  setTimeout(() => {
    filterItemList.value.forEach((i) =>
      item.name !== i.name ? (i.checked = false) : true
    );
    inputValue.value = null;
  }, 250);
};

const searchLocation = () => {
  let emitObject = {};
  emitObject[filterBadge.value[0].name] = inputValue.value;
  emit("onFilterSearch", emitObject);
};
const inputNull = () => {
  if (inputValue.value === "" || inputValue.value === null) {
    emit("onFilterSearch", null);
  }
};

createFilterList();

onMounted(() => {
  var input = document.querySelector(`#search-input-button-${props.searchId}`);

  document.addEventListener("click", (e) => {
    if (e.composedPath().includes(input)) {
      filterMenuShow.value = true;
    } else {
      filterMenuShow.value = false;
    }
  });
});
</script>

<style scoped>
.input-Filter-search {
  border: 1px solid #e8ebee;
  border-width: 1px 0 1px 1px;
  border-radius: 5px 0 0 5px;
  background-color: #fff;
}
.input-Filter-search:focus-visible {
  background-color: #fcfcfc;
  color: #424242;
}

.border-radius-right {
  border-color: #e8ebee !important;
  border-radius: 0 5px 5px 0 !important;
  background-color: #fcfcfc;
}
.select-menu-list {
  right: 0;
  top: 47px;
  width: 200px;
  background-color: #fff;
  padding: 4px 2px 2px 2px;
  z-index: 5;
}
.select-menu-list li {
  list-style-type: none;
  margin-bottom: 2px;
  padding: 4px 2px 4px 5px;
  color: #3f4254;
}
.select-menu-list li:hover {
  background-color: #386dcd;
  font-weight: 500;
  color: #fff;
}
.select-item {
  background-color: #214cc5;
  color: #fff !important;
  font-weight: 500;
}
.made-enter-active,
.made-leave-active {
  transition: opacity 0.2s ease;
}

.made-enter-from,
.made-leave-to {
  opacity: 0;
}
</style>
